import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import createMetadataAPISelectors from '../../utils/api-metadata-selectors';

const options = {
  name: 'ranks',
  baseType: 'RANKS',
  apiEndpoint: 'ranks'
};

const operations = createMetadataAPIOperations(options);
const selectors = createMetadataAPISelectors(options);

export { operations, selectors };
export default createMetadataAPIReducer(options);
